/**
 *  @name onDOMContentLoaded
 *  @author sviatoslav@creditninja.com
 *  @version 1.0.0
 *
 *  @copyright Copyright (c) CreditNinja, LTD.
 */
const onDOMContentLoaded = (callbackList) => {
    const runCallbacks = () => callbackList.forEach((cb) => cb());
    const isDOMContentLoadedPhaseMissed = () => document.readyState !== 'loading';
    if (isDOMContentLoadedPhaseMissed()) {
        runCallbacks();
    }
    else {
        document.addEventListener('DOMContentLoaded', runCallbacks);
    }
};
export default onDOMContentLoaded;
